
export interface PlusLoadModalStore {
  open: boolean,
  // settingsOpen: boolean,
}

export enum PlusLoadModalActions {
  OPEN_PLUS_LOAD_MODAL = 'OPEN_PLUS_LOAD_MODAL',
  CLOSE_PLUS_LOAD_MODAL = 'CLOSE_PLUS_LOAD_MODAL',
  // TOGGLE_NOTIFICATION_SETTINGS = 'TOGGLE_NOTIFICATION_SETTINGS',
}

const createDefaultState = (): PlusLoadModalStore => ({
  open: false,
  // settingsOpen: false,
})


const createPlusLoadModalStoreReducer = () => (state: PlusLoadModalStore = createDefaultState(), action: any): PlusLoadModalStore => {
  switch (action.type) {
    case PlusLoadModalActions.OPEN_PLUS_LOAD_MODAL: {
      return {
        ...state,
        open: true,
      }
    }
    case PlusLoadModalActions.CLOSE_PLUS_LOAD_MODAL: {
      return {
        ...state,
        open: false,
      }
    }
    default: {
      return state
    }
  }
}


export default createPlusLoadModalStoreReducer
